export default {
  deposit: {
    crypto: '暗号資産',
    fiatOrCash: '法定通貨/現金',
    depositCurrency: '入金通貨',
    chooseNetwork: 'ネットワーク選択',
    depositAddress: '入金アドレス',
    copy: 'コピー',
    copied: 'コピーしました！',
    close: '閉じる',
    more: 'もっと見る',
    select: '選択',
    channel: 'チャンネル',
    loading: '読み込み中...',
    noCurrency: '利用可能な通貨がありません',
    bonusTip: '初回入金で最大200％の追加クレジットボーナスをお楽しみください。',
    minDeposit: '最低入金額',
    sendOnly: 'このアドレスには{currency}のみを送付してください。{confirmations}回のネットワーク確認後、自動的に入金されます。',
    depositAmount: '入金額',
    enterAmount: '金額を入力',
    confirmDeposit: '入金確定',
    depositTitle: '入金',
    selectChannel: 'チャンネルを選択',
    subtitle: '速くて安全、便利',
    secureEncrypted: '安全かつ暗号化',
    terms: '続行すると、利用規約に同意したものとみなされます',
    totalDepositAmount: '入金合計額',
    fee: '手数料',
    arrivalAmount: '入金される金額',
    payMethod: 'お支払い方法',
    cpf: 'CPF',
    enterCpf: 'CPFを入力してください',
    depositSuccess: '入金が成功しました！',
    depositFailed: '入金に失敗しました。再度お試しください。',
    mockArrive: '入金シミュレーション（テスト）',
    activity: {
      firstChargeTitle: '初回入金登録イベント',
      firstChargeSubtitle: '初回入金を登録して限定報酬を受け取ろう',
      dailyThreeTitle: '毎日3回入金',
      dailyThreeSubtitle: '毎日3回入金を完了して追加ボーナスを受け取ろう',
      dailyPreviewLabel: '初回入金報酬',
      upTo: '最大 {amount} {unit}',
      safeTitle: 'お客様の資金は安全に保護されます',
      safeDesc: '業界最高水準のセキュリティで取引と個人情報を保護します。',
      dailyFirst: '毎日1回目の入金',
      dailySecond: '毎日2回目の入金',
      dailyThird: '毎日3回目の入金',
      lossReward: '損失リベート',
      lossRewardSubtitle: '損失分のキャッシュバックを受け取れます',
      rebateUpTo: '最大 {ratio}% のリベート',
      notEligible: 'このアクティビティには参加できません',
      lossNeedSelect: '入金時にこのアクティビティを選択するとキャッシュバックに参加できます',
      claimed: '受取済み',
      claim: '受け取る',
      noTier: '段階がありません',
      claimWillOpen: '受取開放時刻 {time}',
      claimTimeNotReached: '受取時間に達していません。{time}以降にもう一度お試しください。',
      bonus: 'ボーナス',
      rebate: 'リベート',
      depositGE: '入金 ≥ {amount}',
      lossGE: '損失 ≥ {amount}',
      claimSuccess: '受け取りに成功しました',
      claimFailed: '受け取りに失敗しました',
      alreadyClaimed: 'この段階は既に受け取り済みです。重複クリックしないでください。',
      lossAlreadyClaimed: 'この段階の損失リベートは既に受け取り済みです。重複クリックしないでください。',
      requireLogin: '受け取る前にログインしてください。',
      depositNotEnough: '入金額が条件に達していません。引き続き頑張ってください！',
      lossNotEnough: '昨日の損失額が条件に達していません。',
      onlyHighest: 'このアクティビティの報酬は最高ランクのみ受け取れます。',
    },
  },
};
